export const API_SUCCESS = 'API_SUCCESS';

export const VEGHICLEMODELLOADING = 'VEGHICLEMODELLOADING';
export const VEGHICLEMODELLOADED = 'VEGHICLEMODELLOADED';

export const VEGHICLESUBMODELLOADING = 'VEGHICLESUBMODELLOADING';
export const VEGHICLESUBMODELLOADED = 'VEGHICLESUBMODELLOADED';

export const CLAIMSLISTSLOADING = 'CLAIMSLISTSLOADING';
export const CLAIMSLISTSLOADED = 'CLAIMSLISTSLOADED';

export const ADDCLAIMLOADING = 'ADDCLAIMLOADING';
export const ADDCLAIMLOADED = 'ADDCLAIMLOADED';

export const POLICIESLOADING = 'POLICIESLOADING';
export const POLICIESLOADED = 'POLICIESLOADED';

